<div class="custom-nav" fxLayout="row">
  <div class="custom-nav__logo" fxFlex="50" fxLayoutAlign="start center">
    <a routerLink="/" id="logo1"></a>
    <a routerLink="/" id="logo2"></a>
    <span>&reg;</span>
  </div>
  <div *ngIf="user" class="custom-nav__profile" fxFlex="50" fxLayoutAlign="end center">

    <!-- Dark / Light Mode -->
    <button mat-icon-button aria-label="Dark & Light Mode" (click)="switchMode()">
      <mat-icon class="material-icons-outlined">{{ lightTheme ? 'dark_mode' : 'light_mode' }}</mat-icon>
    </button>

    <!-- Admin Settings -->
    <a *ngIf="user.typeId !== 3" mat-icon-button aria-label="Admin Settings" routerLink="/user/admin">
      <mat-icon class="material-icons-outlined">settings</mat-icon>
    </a>

    <!-- Notifications -->
    <button mat-icon-button aria-label="Notifications Menu" class="open-notifications"
            (click)="isNotificationOpened = !isNotificationOpened"
            [disabled]="!notifications || (notifications && notifications.length === 0)">
      <mat-icon class="material-icons-outlined"
                [matBadge]="( !notifications || (notifications && notifications.length === 0) ) ? null : notifications.length"
                matBadgeSize="small"
                matBadgeColor="warn">
        notifications
      </mat-icon>
    </button>

    <app-notifications *ngIf="isNotificationOpened"
                       [notifications]="notifications"
                       (clickOutside)="clickOutside()"
                       [exclude]="'.dismiss, .open-notifications'"
                       (reloadNotifications)="getNotifications()">
    </app-notifications>

    <!-- Menu -->
    <button mat-button [matMenuTriggerFor]="menu">
      {{ user.firstName }} {{ user.lastName }}
    </button>
    <mat-menu #menu="matMenu">
      <a routerLink="/user/profile" mat-menu-item>
        <mat-icon class="material-icons-outlined">account_circle</mat-icon>
        <span>Profile</span>
      </a>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</div>
